import { useMediaQuery, useTheme } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { userAttributesSlice } from '!core/redux/userAttributes';
import { currentOTPDeliveryMethod } from '!core/redux/userAttributes/userAttributes.selectors';
import { useHandleSagaError } from '»utils/customHooks';

import { TrlRadioOptions } from '../TrlRadioOptions';
import { trlOTPDeliveryMethodServices } from './trlOTPDeliveryMethod.services';

export const TrlOTPDeliveryMethod = () => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));

  const [deliveryMethods, setDeliveryMethods] = useState([]);

  const currentDeliveryMethod = useSelector(currentOTPDeliveryMethod);

  const { handleSagaError } = useHandleSagaError();

  const getMethods = () => {
    trlOTPDeliveryMethodServices
      .getDeliveryMethods()
      .then((methods) => {
        const refactoredMethods = methods.reduce((acc, method) => {
          acc.push({
            id: method.notificationTypeId,
            label: method.descr,
          });

          return acc;
        }, []);

        setDeliveryMethods(refactoredMethods);
      })
      .catch((error) => {
        handleSagaError(error);
      });
  };

  useEffect(() => {
    dispatch(
      userAttributesSlice.actions.getUserAttributesRequest({
        id: 'OTP_DELIVERY_METHOD',
      }),
    );

    getMethods();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const changeOTPDeliveryMethod = (event) => {
    dispatch(
      userAttributesSlice.actions.setUserAttributeRequest({
        id: 'OTP_DELIVERY_METHOD',
        value: event.target.value,
      }),
    );
  };

  return (
    <TrlRadioOptions
      title="TRLT_UI-TOKEN_METHOD"
      descr="TRLT_UI-TOKEN_SELECTOR"
      options={deliveryMethods}
      selectedOptionId={currentDeliveryMethod}
      handleChange={changeOTPDeliveryMethod}
      width={isDesktop && '457px'}
    />
  );
};
